import { useContext } from 'react';
import { ToastContext, type ShowToast } from './toastContext';

/**
 * Access the toast trigger. Must be called within a `ToastProvider` (the shell
 * mounts one around the gated app).
 */
export function useToast(): ShowToast {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within a ToastProvider');
  return ctx;
}
